import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { translate } from "react-i18next";
import Typography from "@material-ui/core/Typography";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import RangeCalendar from "rc-calendar/lib/RangeCalendar";
import "rc-calendar/assets/index.css";
import DateRangeIcon from "@material-ui/icons/DateRange";
import Picker from "rc-calendar/lib/Picker";
import Button from "@material-ui/core/Button";
import moment from "moment";
import "react-image-lightbox/style.css";

import { THEME, DATE_FORMAT } from "../_constants";
import { chartActions } from "../_actions";

const CAROUSEL_HEIGHT = 200;

const styles = theme => ({
    container: {
        width: "100%",
        height:"100%",
        backgroundColor: THEME.COLOR.MAIN,
        display: "flex",
        flexDirection: "column",
        padding: 2,
        zIndex: 1,
        shadowColor: "#0f0",
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.8,
        shadowRadius: 2,
        elevation: 1,
        overflow: "auto"
    },
    group: {
        backgroundColor: "#2f3846"
    },
    infoItem: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyItems: "space-between",
        marginTop: 5,
        marginBottom: 5
    },
    infoItem_title: {
        maxWidth: 150,
        color: THEME.COLOR.GRAY
    },
    infoItem_value: {
        flex: 1,
        color: THEME.COLOR.GRAY,
        textAlign: "right"
    },
    progressBar: {
        marginLeft: 25,
        marginRight: 25,
        backgroundColor: THEME.COLOR.GRAY
    },
    field: {
        alignSelf: "center",
        alignItems: "center",
        width: "100%",
        display: "flex",
        flexDirection: "row"
    },
    dateButton: {
        width: "100%",
        margin: 0,
        padding: 10,
        minWidth:"110px",
        textTransform: "none",
        color: THEME.COLOR.GRAY,
        borderColor: THEME.COLOR.GRAY
    },
    rightIcon: {
        marginLeft: "auto",
        marginRight: 0,
        color: THEME.COLOR.GRAY
    },
    chip: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        borderRadius: THEME.BORDER.RADIUS
    },
    carousel: {
        minHeight: CAROUSEL_HEIGHT,
        maxHeight: CAROUSEL_HEIGHT,
        display: "flex"
    },
    swipeable: {
        height: "100%",
        flex: "0 0 100%"
    },
    img: {
        height: CAROUSEL_HEIGHT,
        width: "100%",
        overflow: "hidden"
    },
    stepper: {
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        width: "100%",
        height: 20,
        marginLeft: "calc(-100%)",
        marginTop: CAROUSEL_HEIGHT - 35
    }
});

//#region CChip
const now = moment();
//#endregion DateTime Helper

class ChartFilter extends React.Component {
    //#region Life cycle
    constructor(props) {
        super(props);

        let campaign = props.campaign;
        this.state = this.getDefaultStateForCampaign(campaign);
    }

    componentDidMount() {
        this.updateFilterWithState(this.state);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.campaign.id !== this.props.campaign.id) {
            let campaign = nextProps.campaign;

            this.setState(this.getDefaultStateForCampaign(campaign));
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.selectedDateRange !== this.state.selectedDateRange
        ) {
            this.updateFilterWithState(this.state);
        }
    }
    
    convertDate(date){  //DD/MM/YYYY  => MM/DD/YYYY
        let d= date.split("/")
        let convDate =d[1]+"/"+d[0]+"/"+d[2]
        return moment(convDate)
    }

    getDefaultStateForCampaign(campaign) {
        let startDate = this.convertDate(campaign.startDate)
        let endDate = this.convertDate(campaign.endDate)
        let defaultDateRange = [startDate, endDate];
        let defaultSelectedTimeSlots = campaign.params.timeSlots.slice();
        let defaultSelectedZones = campaign.params.zones.slice();

        let state = {
            selectedDateRange: defaultDateRange,
            hoverDateValue: defaultDateRange,
            selectedTimeSlots: defaultSelectedTimeSlots,
            selectedZones: defaultSelectedZones
        };

        return state;
    }
    //#endregion Life cycle

    //#region actions
    //#region Filter
    //#region date range
    getFilterFromState(state) {
        let campaign = this.props.campaign;

        let startDateStr = state.selectedDateRange[0].format(DATE_FORMAT);
        let endDateStr = state.selectedDateRange[1].format(DATE_FORMAT);

        let filter = {
            campaignID: campaign.id,
            startDate: startDateStr,
            endDate: endDateStr,
        };

        return filter;
    }
    updateFilterWithState(state) {
        let filter = this.getFilterFromState(state);
        this.props.dispatch(chartActions.getCharts(filter));
    }
    onChangeSelectedDateRange = selectedDateRange => {
        this.setState({ selectedDateRange });
    };

    onHoverChangeDate = hoverDateValue => {
        this.setState({ hoverDateValue });
    };

    render() {
        const { t, classes} = this.props;
        const self = this;
        const state = this.state;

        function renderExpansionPanel(title, content) {
            return (
                <ExpansionPanel
                    defaultExpanded
                    className={classes.group}
                    style={{ marginTop: 3, marginBottom: 0 }}
                >
                    <ExpansionPanelSummary
                        expandIcon={
                            <ExpandMoreIcon
                                style={{ color: THEME.COLOR.GRAY }}
                            />
                        }
                    >
                        <Typography
                            variant="body2"
                            className={classes.infoItem_title}
                        >
                            {title}
                        </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>{content}</ExpansionPanelDetails>
                </ExpansionPanel>
            );
        }

        function renderDateRangeInput() {
            const calendar = (
                <RangeCalendar
                    hoverValue={state.hoverDateValue}
                    onHoverChange={self.onHoverChangeDate}
                    showWeekNumber={false}
                    dateInputPlaceholder={[t("FromDate"), t("ToDate")]}
                    defaultValue={[now, now.clone().add(1, "months")]}
                />
            );

            function renderDateRange(startDate = null, endDate = null) {
                function renderCalendarButton(title, action) {
                    return (
                        <Button
                            variant="outlined"
                            className={classes.dateButton}
                        >
                            {title}
                            <DateRangeIcon className={classes.rightIcon} />
                        </Button>
                    );
                }

                let fromDateStr =
                    startDate == null
                        ? t("FromDate")
                        : startDate.format(DATE_FORMAT);
                let toDateStr =
                    endDate == null ? t("ToDate") : endDate.format(DATE_FORMAT);

                return (
                    <div className={classes.field}>
                        {renderCalendarButton(fromDateStr, null)}
                        <div
                            style={{
                                flexBasis: 50,
                                textAlign: "center",
                                color: THEME.COLOR.GRAY
                            }}
                        >
                            -
                        </div>
                        {renderCalendarButton(toDateStr, null)}
                    </div>
                );
            }

            return (
                <Picker
                    value={state.selectedDateRange}
                    onChange={self.onChangeSelectedDateRange}
                    animation="slide-up"
                    calendar={calendar}
                >
                    {({ value }) => {
                        return renderDateRange(value[0], value[1]);
                    }}
                </Picker>
            );
        }

        return (
            <div className={classes.container}>
                {renderExpansionPanel(t("Date"), renderDateRangeInput())}            
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

const connectedFilter = connect(mapStateToProps)(ChartFilter);

export default withStyles(styles)(translate("translations")(connectedFilter));



// WEBPACK FOOTER //
// ./src/CampaignDetailCharts/ChartFilter.js